/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentModelSupportResponse
} from './model/agentModelSupportResponse.js';

import type {
  ListPluginManifests200Item
} from './model/listPluginManifests200Item.js';

import type {
  PublicConfig
} from './model/publicConfig.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get the server's public configuration.
 */
export const getConfig = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<PublicConfig>(
      {url: `/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigQueryKey = () => {
    return [
    `/config`
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = unknown


/**
 * @summary Get the server's public configuration.
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List the agent types, model providers, and models available to the caller.
 */
export const getAgentModelSupport = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentModelSupportResponse>(
      {url: `/config/agent-model-support`, method: 'GET', signal
    },
      options);
    }




export const getGetAgentModelSupportQueryKey = () => {
    return [
    `/config/agent-model-support`
    ] as const;
    }


export const getGetAgentModelSupportQueryOptions = <TData = Awaited<ReturnType<typeof getAgentModelSupport>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentModelSupport>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentModelSupportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentModelSupport>>> = ({ signal }) => getAgentModelSupport(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentModelSupport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentModelSupportQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentModelSupport>>>
export type GetAgentModelSupportQueryError = unknown


/**
 * @summary List the agent types, model providers, and models available to the caller.
 */

export function useGetAgentModelSupport<TData = Awaited<ReturnType<typeof getAgentModelSupport>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentModelSupport>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentModelSupportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List plugin manifests
 */
export const listPluginManifests = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListPluginManifests200Item[]>(
      {url: `/config/plugins`, method: 'GET', signal
    },
      options);
    }




export const getListPluginManifestsQueryKey = () => {
    return [
    `/config/plugins`
    ] as const;
    }


export const getListPluginManifestsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginManifests>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginManifests>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginManifestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginManifests>>> = ({ signal }) => listPluginManifests(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginManifests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginManifestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginManifests>>>
export type ListPluginManifestsQueryError = unknown


/**
 * @summary List plugin manifests
 */

export function useListPluginManifests<TData = Awaited<ReturnType<typeof listPluginManifests>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginManifests>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginManifestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






